var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LoggedInSidebar'),_c('div',{staticClass:"view",on:{"click":_vm.closeSidebar}},[_c('LoggedInHeader'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }